import request from '@/CommonDP/utils/request';
import globalParams from "@/CommonDP/utils/globalParams";
// 目录相关接口
export default {
  // 查询当前项目是否已经初始化 false 代表没初始化过
  checkCatalogIsInit(params) {
    const store = require("@/store/index").default;
    const isIgnoreDirPlan = globalParams.get("isIgnoreDirPlan");
    if(isIgnoreDirPlan) return { data: true }; // 忽略关键目录设置
    const judgeIsUseNewFolder = store.state.enterprise.judgeIsUseNewFolder;
    if (judgeIsUseNewFolder) {
      return request.get('/dynamic/isInit', { params });
    } else {
      return request.get('/dyna/isInit', { params });
    }
  },
  queryKeyCatalogList(params) {
    return request.post('/dyna/home', params);
  },
  querySpecList(params) {
    return request.get('/prj-spec-plan/spec-list', { params });
  },
  queryspeclist2(params) {
    return request
      .get(`/enterprise/spec/getListByEnterpriseId`, { params })
      .then((res) => res)
      .catch((err) => Promise.reject(err));
  },
  queryStageList(params) {
    return request.get('/enterprise/stage/getListByEnterpriseId', {
      params
    });
  },

  addEnterpriseStage(json) {
    return request.post('/enterprise/stage/add', json);
  },
  saveChange(params) {
    return request.post('/dyna/saveChange', params);
  },
  rollback(params) {
    return request.get('/dyna/rollback', { params });
  },
  publishChange(params) {
    return request.post('/dyna/publish', params);
  },
  dynapreview(params) {
    return request.post('/dyna/preview', params);
  },
  queryDisabled(params) {
    return request
      .post("/dyna/query/disabled", params)
      .then(res => res);
  },
  dynaDisabled(params) {
    return request
      .post("/dyna/disabled", params)
      .then(res => res);
  },
  dynaEnabled(params) {
    return request
      .post("/dyna/enabled", params)
      .then(res => res);
  },
  // 动态目录(新)
  queryDynamicHomeList(params) {
    return request.post('/dynamic/home', params);
  },
  // 动态目录导出
  exportPrjPlan (params) {
    return request({
      url: '/dynamic/export',
      method: 'post',
      responseType: 'blob',
      data: params
    });
  },
  // 发布
  publishDynamic(params) {
    return request.post('/dynamic/newPublish', params);
  },
  queryChildList(params) {
    return request.get('/dynamic/child/list', {
      params
    });
  },
  queryUnitList(params) {
    return request.get('/dynamic/unit/list', {
      params
    });
  },
  addPrjChild(params) {
    return request.post('/dynamic/child/save', params);
  },
  dynamicUnitSave(params) {
    return request.post('/dynamic/unit/save', params);
  },
  dynamicChildDelete(id) {
    return request.post('/dynamic/child/delete?id=' + id);
  },
  dynamicUnitDelete(id) {
    return request.post('/dynamic/unit/delete?id=' + id);
  },
  // 判断当前企业是否用新目录
  dynamicJudgeIsUseNewFolder(prjId) {
    return request.get('/dynamic/judgeIsUseNewFolder?prjId=' + (prjId || ""));
  },
  // 预览
  dynamicPreview(params) {
    return request.post('/dynamic/preview', params);
  },
  // 恢复至上一次发布状态
  dynamicRollback(params) {
    return request.get('/dynamic/rollback', { params });
  },
  // 保存更改
  dynamicSaveChange(params) {
    return request.post('/dynamic/saveChange', params);
  }

};
